import { Modal } from '@mantine/core';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Button } from '@/DesignSystem/Component';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import { useDeviceType } from '@/Module/Core/Hook';
import { DeviceType } from '@/Module/Core/Model/Enum';
import { useCampaign } from '@/Module/DefaultLayout/Hook';
import { IconCrossMark } from '@/Module/Icon';
import { useAppSelector } from '@/Module/Store/Hook';
const SubscriptionPopup: FC = () => {
  const router = useRouter();
  const isLoggedIn = useAppSelector(state => state.auth.isLoggedIn);
  const isMobile = useDeviceType();
  const [isOpen, setOpen] = useState(false);
  const {
    popup,
    desktopPopup,
    mobilePopup
  } = useCampaign();
  const [ctaLink, alt, imageSource, width, height] = useMemo(() => {
    if (isMobile === DeviceType.MOBILE && mobilePopup) {
      return [mobilePopup?.ctaLink || '', mobilePopup?.alt || '', `${FILE_BROWSER_URL}/campaign/${mobilePopup?.image || ''}`, 375, 480];
    }
    if (desktopPopup) {
      return [desktopPopup?.ctaLink || '', desktopPopup?.alt || '', `${FILE_BROWSER_URL}/campaign/${desktopPopup?.image || ''}`, 620, 318];
    }
    return ['', '', ''];
  }, [isMobile, popup?.isActive, desktopPopup, mobilePopup]);
  const setLocalStorageKey = useCallback(() => {
    if (!popup?.key) return;
    localStorage.setItem(popup?.key, 'true');
  }, [popup?.key]);
  const isOpenedBefore = useCallback(() => {
    if (!popup?.key) return false;
    return localStorage.getItem(popup?.key) === 'true';
  }, [popup?.key]);
  useEffect(() => {
    if (isOpenedBefore()) return () => {};
    if (isLoggedIn) return () => {};
    if (router.pathname.includes('auth')) return () => {};
    if (!popup?.isActive || !desktopPopup && !mobilePopup) return () => {};
    const timeout = setTimeout(() => {
      setOpen(true);
    }, (popup?.time ?? 20) * 1000);
    return () => {
      clearTimeout(timeout);
      setOpen(false);
    };
  }, [router, popup?.isActive, popup?.time, desktopPopup, mobilePopup]);
  return <Modal role="dialog" opened={isOpen} onClose={() => {
    setOpen(false);
    setLocalStorageKey();
  }} withCloseButton={false} size={isMobile === DeviceType.MOBILE ? 'sm' : 'lg'} centered classNames={{
    body: 'p-0 w-fit',
    content: 'bg-transparent'
  }} aria-labelledby="dialog-title" aria-label="dialog-title" transitionProps={{
    transition: 'rotate-left'
  }} data-sentry-element="Modal" data-sentry-component="SubscriptionPopup" data-sentry-source-file="SubscriptionPopup.tsx">
      <div className="relative w-fit">
        {ctaLink && imageSource && alt && <Link className="w-fit" href={ctaLink} target="_blank" onClick={() => {
        setOpen(false);
        setLocalStorageKey();
      }}>
            <div>
              <h2 id="dialog-title" className="sr-only">
                تبلیغات
              </h2>
              <Image alt={alt} src={imageSource} className="z-0" width={width} height={height} priority />
            </div>
          </Link>}
        <Button size="small" radius="circle" variant="shadow" color="white" ariaLabel="close popup" onClick={() => {
        setOpen(false);
        setLocalStorageKey();
      }} iconButton className="!absolute right-4 top-3 z-10 bg-white shadow-modalClose md:right-2 md:top-2" data-sentry-element="Button" data-sentry-source-file="SubscriptionPopup.tsx">
          <IconCrossMark data-sentry-element="IconCrossMark" data-sentry-source-file="SubscriptionPopup.tsx" />
        </Button>
      </div>
    </Modal>;
};
export default SubscriptionPopup;